export const ACCESS_TOKEN = 'accessToken';
export const REDIRECT_BACK_URL = 'redirectBackUrl';

export const GOOGLE_AUTH_URL = process.env.REACT_APP_BACKEND_HOST + '/api/oauth2/authorize/google?redirect_uri=' + process.env.REACT_APP_OAUTH2_REDIRECT_URI;
export const FACEBOOK_AUTH_URL = process.env.REACT_APP_BACKEND_HOST + '/api/oauth2/authorize/facebook?redirect_uri=' + process.env.REACT_APP_OAUTH2_REDIRECT_URI;
export const GITHUB_AUTH_URL = process.env.REACT_APP_BACKEND_HOST + '/api/oauth2/authorize/github?redirect_uri=' + process.env.REACT_APP_OAUTH2_REDIRECT_URI;
